'use client';

import { useEffect, useState } from 'react';

const ROTATING_OUTCOMES = [
	'every vote cast on referendum #1839.',
	'the Polkadot treasury value in USD.',
	'the name behind any wallet address.',
	'how conviction voting really works.',
	'the top OpenGov whales right now.',
	"any validator's commission history."
];

export default function HeroRotatingText() {
	const [wordIndex, setWordIndex] = useState(0);
	const [isFading, setIsFading] = useState(false);

	// Fade out → swap word → fade in cycle
	useEffect(() => {
		const interval = setInterval(() => {
			setIsFading(true);
		}, 2800);
		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		if (!isFading) return;
		const timer = setTimeout(() => {
			setWordIndex((i) => (i + 1) % ROTATING_OUTCOMES.length);
			setIsFading(false);
		}, 350);
		return () => clearTimeout(timer);
	}, [isFading]);

	return (
		<span
			className={`inline-block bg-gradient-to-r from-pink-400 to-pink-600 bg-clip-text text-transparent transition-all duration-350 ease-in-out ${isFading ? 'translate-y-1 opacity-0' : 'translate-y-0 opacity-100'}`}
		>
			{ROTATING_OUTCOMES[wordIndex]}
		</span>
	);
}
